<template>
	<div
		class="relative flex items-center justify-center overflow-hidden select-none"
	>
		<img
			v-show="loaded"
			:src="src"
			:srcset="srcset"
			:alt="alt"
			@error="onError"
			@load="onLoad"
			@loaded="onLoad"
			class="max-h-full max-w-full"
		/>
		<div
			class="absolute inset-0 flex items-center justify-center"
			v-if="!loaded"
		>
			<slot>
				<StickerPreloader v-if="preloader" :preloader="preloader" />
				<div
					v-else
					class="bg-fill-secondary h-8 w-8 animate-pulse rounded-full"
				/>
			</slot>
		</div>
	</div>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue'
import StickerPreloader from './StickerPreloader.vue'

const props = defineProps<{
	src: string
	srcset?: string
	alt: string
	preloader?: string
}>()

const emit = defineEmits<{
	(e: 'loaded'): void
	(e: 'error'): void
}>()

const error = ref(false)
const loaded = ref(false)

watch(
	() => props.src,
	() => {
		error.value = false
		loaded.value = false
	}
)

const onError = () => {
	emit('error')
}

const onLoad = () => {
	emit('loaded')
	loaded.value = true
}
</script>
